import { observer } from 'mobx-react';
import moment from 'moment';
import { Button } from 'primereact/button';
import { Column, ColumnProps } from 'primereact/column';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import React, { RefObject } from 'react';
import { RouterProps } from 'react-router';
import { Flex } from 'reflexbox';

import qs from 'qs';
import { DataSource } from '../../models/DataSource';
import { DataTableFilterService } from '../../services/DataTableFilterService';
import { MonitoringRestService } from '../../services/MonitoringRestService';
import { DependencyContainer } from '../../utils/DependencyInjection';
import { IAwbListFilterContainerValue, AwbListFilterContainer } from './AwbListFilterContainer';
import { AwbDetailModalComponent } from '../awb/AwbDetailModalComponent';
import { Dialog } from 'primereact/dialog';
import { DateHelper } from '../../utils/DateHelper';

export interface IAwbListContainerQuery {
  filters: IAwbListFilterContainerValue;
}

@observer
export class AwbListContainer extends React.Component<RouterProps, any> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);

  data;
  dt;
  growl: any;
  dataSource = new DataSource<any>();
  refFilter: RefObject<AwbListFilterContainer> = React.createRef();
  refAwbDetailModal: RefObject<AwbDetailModalComponent> = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      exportExcelLoading: false,
      showExportDialog: false,
      filterCollapsed: false,
      sortField: null,
      sortOrder: null
    }
  }

  componentDidMount() {
    const queryFilter = (this.props.history.location.search)
      ? qs.parse(
        this.props.history.location.search.substr(1),
      ) as any
      : {} as any;

    if (queryFilter && queryFilter.filters) {
      if (this.refFilter.current) {
        const newFilters = this.refFilter.current.setFormValues(queryFilter.filters);
        this.loadData(newFilters);
      }
    }

    this.dataSource.onPageChange.subscribe(() => {
      this.loadData();
    });
  }

  loadData(filterParams: any = null) {
    const pagingParams = { limit: this.dataSource.rows, page: this.dataSource.page };
    const sortingParams = { sortField: this.state.sortField, sortOrder: (this.state.sortOrder === -1) ? 'desc' : 'asc' }

    const fParams = (filterParams)
      ? Object.assign({}, filterParams, pagingParams, sortingParams)
      : Object.assign({}, this.refFilter.current!.formValues, pagingParams, sortingParams);

    if (fParams.startDate) fParams.startDate = DateHelper.formatLocalDateForQueryParam(fParams.startDate);
    if (fParams.endDate) fParams.endDate = DateHelper.formatLocalDateForQueryParam(fParams.endDate);

    if (DateHelper.isDateRangeMoreThanOneMonth(fParams.startDate, fParams.endDate)) return null;

    this.dataSource.loading = true;
    this.monitoringRestService
      .post('awb-list', fParams)
      .subscribe(
        response => {
          this.data = response;
          this.populateDataSource();
        },
        () => {
          this.dataSource.loading = false;
        },
        () => {
          this.dataSource.loading = false;
        }
      );
  }

  downloadCsv(filterParams: any = null) {
    this.setState({ exportExcelLoading: true, showExportDialog: true });

    const fParams = (filterParams)
      ? Object.assign({}, filterParams)
      : Object.assign({}, this.refFilter.current!.formValues);

    if (fParams.startDate) fParams.startDate = DateHelper.formatLocalDateForQueryParam(fParams.startDate);
    if (fParams.endDate) fParams.endDate = DateHelper.formatLocalDateForQueryParam(fParams.endDate);

    if (DateHelper.isDateRangeMoreThanOneMonth(fParams.startDate, fParams.endDate)) {
      this.setState({ exportExcelLoading: false, showExportDialog: false });
      return null;
    }

    this.monitoringRestService
      .post('awb-list-csv', fParams)
      .subscribe(
        response => {
          if (response && response.path) {
            this.openCsv(response.path);
          }
        },
        () => {
          let msg = { severity: 'error', summary: 'Error Message', detail: 'Export failed' };
          this.growl.show(msg);
          this.setState({ exportExcelLoading: false, showExportDialog: false });
        },
        () => {
          let msg = { severity: 'success', summary: 'Success Message', detail: 'Export Success' };
          this.growl.show(msg);
          this.setState({ exportExcelLoading: false, showExportDialog: false });
        },
      );
  }

  openCsv(url) {
    // const win = window.open(url, '_blank');
    // if (win) win.focus();
    window.location = url;
  }

  populateDataSource() {
    if (this.data.data && this.data.data.length) {
      this.dataSource.setData(this.data.data);
      this.dataSource.setTotal(this.data.count);
    } else {
      this.dataSource.setData([]);
      this.dataSource.setTotal(0);
    }
  }

  onClickAwbNumber = (awbNumber) => {
    this.refAwbDetailModal.current!.handleShow(awbNumber);
  }

  columnAwbNumber = (rowData, column: ColumnProps) => {
    return (
      <a onClick={() => this.onClickAwbNumber(rowData[column.field!])}>{rowData[column.field!]}</a>
    );
  }

  columnDateFormat = (rowData, column: ColumnProps) => {
    return (
      (rowData[column.field!] != null) ? moment(new Date(rowData[column.field!])).utc().format('DD-MM-YYYY HH:mm') : ''
    );
  }

  async onSorting(e) {
    if (e && e.sortField) {
      const sortOrder = (this.state.sortField === e.sortField)
        ? (this.state.sortOrder === 1) ? -1 : 1
        : 1;
      await this.setState({ sortField: e.sortField, sortOrder: sortOrder })
    } else {
      await this.setState({ sortField: null, sortOrder: null })
    }

    console.log(e);
    console.log(this.state);
    await this.loadData();
  }

  render() {
    const footer = 'Total data: ' + this.dataSource.total;

    return (
      <div>
        <AwbDetailModalComponent ref={this.refAwbDetailModal} />

        <Dialog header="Informasi" visible={this.state.showExportDialog} style={{ width: '40vw' }} modal={true} onHide={() => this.setState({ showExportDialog: false })}>
          Export excel sedang berjalan, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Growl ref={el => (this.growl = el)} style={{ marginTop: '75px' }} />

        <Flex className="card w-full">
          <Flex className="w-full" column>
            <AwbListFilterContainer ref={this.refFilter} />
            <br />
            <Flex>
              <Button
                className="p-button-success mr-2"
                label="Tampilkan"
                onClick={
                  () => {
                    this.dataSource.setPage(1);
                  }
                }
              />
              <Button
                className="p-button-primary"
                label="Export Excel"
                icon={(this.state.exportExcelLoading) ? "pi pi-spin pi-spinner" : ""}
                disabled={(this.state.exportExcelLoading)}
                onClick={() => this.downloadCsv()}
              />
            </Flex>
          </Flex>
        </Flex>

        <div className="card">
          <DataTable
            ref={(el) => this.dt = el}
            emptyMessage={'Tidak ada data untuk ditampilkan.'}
            scrollable={true}
            scrollHeight="550px"
            style={{ width: '100%' }}
            className="mt-4"
            value={this.dataSource.data}
            loading={this.dataSource.loading}
            sortField={this.state.sortField}
            sortOrder={this.state.sortOrder}
            onSort={
              (e) => {
                this.onSorting(e);
              }
            }
            // onValueChange={() => this.loadData()}
            footer={footer}>
            <Column
              field="receiptNumber"
              header="No Resi"
              sortable={true}
              style={{ width: '130px', "vertical-align": 'text-top' }}
              body={this.columnAwbNumber}
            />
            <Column
              field="tglTransaksi"
              header="Tgl. Transaksi"
              body={this.columnDateFormat}
              sortable={true}
              style={{ width: '145px', "vertical-align": 'text-top' }}
            />
            <Column
              field="tglFoto"
              header="Tgl. Foto"
              body={this.columnDateFormat}
              sortable={true}
              style={{ width: '145px', "vertical-align": 'text-top' }}
            />
            <Column
              field="tglInput"
              header="Tgl. Input"
              body={this.columnDateFormat}
              sortable={true}
              style={{ width: '145px', "vertical-align": 'text-top' }}
            />
            <Column
              field="tglFoto"
              header="Tgl. Manifest"
              body={this.columnDateFormat}
              sortable={true}
              style={{ width: '145px', "vertical-align": 'text-top' }}
            />
            <Column
              field="pengirim"
              header="Pengirim"
              sortable={true}
              style={{ width: '200px', "vertical-align": 'text-top' }}
            />
            <Column
              field="partnerName"
              header="Partner Name"
              sortable={true}
              style={{ width: '200px', "vertical-align": 'text-top' }}
            />
            <Column
              field="reseller"
              header="Reseller"
              sortable={false}
              style={{ width: '150px', "vertical-align": 'text-top' }}
            />
            <Column
              field="nohpreseller"
              header="Telp Reseller"
              sortable={false}
              style={{ width: '130px', "vertical-align": 'text-top' }}
            />
            <Column
              field="asal"
              header="Asal"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                return (
                  <div><div><b>{rowData[column.field!]}</b></div><div><small><span>{rowData['asalKota']} ({rowData['asalKecamatan']})</span></small></div></div>
                )
              }}
            />
            <Column
              field="perwakilan"
              header="Perwakilan"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
            />
            <Column
              field="tujuan"
              header="Tujuan"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                return (
                  <div><div><b>{rowData[column.field!]}</b></div><div><small><span>{rowData['tujuanKota']} ({rowData['tujuanKecamatan']})</span></small></div></div>
                )
              }}
            />
            <Column
              field="zonatujuan"
              header="Zona Tujuan"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="layanan"
              header="Layanan"
              sortable={true}
              style={{ width: '90px', "vertical-align": 'text-top' }}
            />
            <Column
              field="PromoCode"
              header="Kode Promo"
              sortable={true}
              style={{ width: '90px', "vertical-align": 'text-top' }}
            />
            <Column
              field="penerima"
              header="Penerima"
              sortable={false}
              style={{ width: '150px', "vertical-align": 'text-top' }}
            />
            <Column
              field="nohpPenerima"
              header="Telp Penerima"
              sortable={false}
              style={{ width: '130px', "vertical-align": 'text-top' }}
            />
            <Column
              field="koli"
              header="Koli"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
            />
            <Column
              field="berat"
              header="Berat"
              sortable={false}
              style={{ width: '100px', "vertical-align": 'text-top' }}
            />
            <Column
              field="beratAsli"
              header="Berat Asli"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
            />
            <Column
              field="beratVolume"
              header="Berat Volume"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
            />
            <Column
              field="ketVolume"
              header="Ket. Volume"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
            />
            <Column
              field="codBiaya"
              header="Biaya COD"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                const colValue = rowData[column.field!];
                const fmtValue = (colValue) ? rowData[column.field!].toLocaleString() : '-';
                return <span>{fmtValue}</span>
              }}
            />
            <Column
              field="codNilai"
              header="Nilai COD"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                const colValue = rowData[column.field!];
                const fmtValue = (colValue) ? rowData[column.field!].toLocaleString() : '-';
                return <span>{fmtValue}</span>
              }}
            />
            <Column
              field="biaya"
              header="Biaya"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                const colValue = rowData[column.field!];
                const fmtValue = (colValue) ? colValue.toLocaleString() : '-';
                return <span>{fmtValue}</span>
              }}
            />
            <Column
              field="totalBiaya"
              header="Total Biaya"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                const colValue = rowData[column.field!];
                const fmtValue = (colValue) ? colValue.toLocaleString() : '-';
                return <span>{fmtValue}</span>
              }}
            />
            <Column
              field="thpReceiptNumber"
              header="Resi Pihak Ketiga"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="noKonfirmasi"
              header="No Konfirmasi"
              sortable={true}
              style={{ width: '240px', "vertical-align": 'text-top' }}
            />
            <Column
              field="slaMin"
              header="Lead Time"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
              body={(rowData) => {
                return <span>{rowData['slaMin']} - {rowData['slaMax']}</span>
              }}
            />
            <Column
              field="slaMax"
              header="SLA Maksimal"
              sortable={true}
              style={{ width: '100px', "vertical-align": 'text-top' }}
            />
            <Column
              field="statusSLA"
              header="Status SLA"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="overSlaInternal"
              header="Over SLA (Internal)"
              sortable={true}
              filter={false}
              style={{ width: '120px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                const tglOverSla = moment(rowData['slaMaxDateTimeInternal']);
                let sTglOverSla: string = '-';
                if (tglOverSla.isValid()) {
                  sTglOverSla = tglOverSla.utc().format('DD-MM-YYYY');
                }

                const overSlaDays = (rowData[column.field!]) && (rowData[column.field!]) > 0 ? rowData[column.field!] : '-';

                return <div><div><b>{overSlaDays} hari</b></div><div><small>{sTglOverSla}</small></div></div>
              }}
            />
            <Column
              field="overSlaExternal"
              header="Over SLA (External)"
              sortable={true}
              filter={false}
              style={{ width: '120px', "vertical-align": 'text-top' }}
              body={(rowData, column: ColumnProps) => {
                const tglOverSla = moment(rowData['slaMaxDateTimeExternal']);
                let sTglOverSla: string = '-';
                if (tglOverSla.isValid()) {
                  sTglOverSla = tglOverSla.utc().format('DD-MM-YYYY');
                }

                const overSlaDays = (rowData[column.field!]) && (rowData[column.field!]) > 0 ? rowData[column.field!] : '-';

                return <div><div><b>{overSlaDays} hari</b></div><div><small>{sTglOverSla}</small></div></div>
              }}
            />
            <Column
              field="usiaPaket"
              header="Usia Paket"
              sortable={true}
              style={{ width: '80px', "vertical-align": 'text-top' }}
            />
            <Column
              field="deliveryDate"
              header="Tgl. Terima Barang"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
              body={this.columnDateFormat}
            />
            <Column
              field="receiverName"
              header="Nama Penerima Barang"
              sortable={true}
              style={{ width: '200px', "vertical-align": 'text-top' }}
            />
            <Column
              field="receiverRemark"
              header="Remark Penerima Barang"
              sortable={true}
              style={{ width: '200px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastStatus"
              header="Last Status"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastStatusDateTime"
              header="Tgl. Last Status"
              body={this.columnDateFormat}
              sortable={true}
              style={{ width: '145px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastStatus2"
              header="Last Status (2)"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastStatusDateTime2"
              header="Tgl. Last Status (2)"
              body={this.columnDateFormat}
              sortable={true}
              style={{ width: '145px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastProblemStatus"
              header="Last Problem"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastProblemStatusDateTime"
              header="Tgl. Last Problem"
              body={this.columnDateFormat}
              sortable={true}
              style={{ width: '145px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastTrackingSiteCode"
              header="Kode Gerai Terakhir"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastTrackingSite"
              header="Gerai Terakhir"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="lastTrackingSiteCity"
              header="Kota Terakhir"
              sortable={true}
              style={{ width: '120px', "vertical-align": 'text-top' }}
            />
            <Column
              field="noteInternal"
              header="Catatan"
              sortable={false}
              style={{ width: '200px', "vertical-align": 'text-top' }}
            />
          </DataTable>

          <Paginator
            totalRecords={this.dataSource.total}
            first={this.dataSource.offset}
            rows={this.dataSource.rows}
            rowsPerPageOptions={this.dataSource.rowsOptions}
            onPageChange={e => this.dataSource.fromPageState(e)}
          />
        </div>
      </div>
    );
  }
}
